import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { NgxsModule } from '@ngxs/store';
import { AppState } from './app.state';
import { ENVIRONMENT, WINDOW } from './common/services/injection-tokens';
import { GlobalErrorHandler } from './common/services/logger/global-error-handler';
import { StartupService, startupServiceFactory } from './common/services/startup.service';
import { AuthenticationService } from './common/services/authentications.service';
import { CoolHttpModule } from '@angular-cool/http';
import { CoolStorageModule } from '@angular-cool/storage';
import { CoolDialogsModule } from '@angular-cool/dialogs';
import { LoggerService } from './common/services/logger/logger.service';
import { UnauthenticatedInterceptor } from './common/services/http/unauthenticated.interceptor';
import { RedirectAfterService } from './common/routing/redirect-after.service';
import { RouteNavigationService } from './common/routing/route-navigation.service';
import { NgxsSelectSnapshotModule } from '@ngxs-labs/select-snapshot';
import { LoggedInRouteGuardLogic } from './common/routing/route-guards/logged-in.guard';
import { GameEntitiesService } from './common/services/game-entities.service';
import { GlobalCacheConfig } from 'ts-cacheable';
import { MINUTE_IN_MILLISECONDS } from '../../../common/utils/date.utils';
import { GameEntityTemplatesService } from './common/services/game-entity-templates.service';
import { CampaignsService } from './common/services/campaigns.service';
import { CampaignPlayersService } from './common/services/campaign-players.service';
import { CampaignSessionsService } from './common/services/campaign-sessions.service';
import { CampaignSessionSectionsService } from './common/services/campaign-session-sections.service';
import { CampaignSessionSectionEntitiesService } from './common/services/campaign-session-section-entities.service';

GlobalCacheConfig.maxCacheCount = 1000;
GlobalCacheConfig.maxAge = 5 * MINUTE_IN_MILLISECONDS;
GlobalCacheConfig.promiseImplementation = Promise;

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ENVIRONMENT, useValue: environment },
    { provide: WINDOW, useValue: window },
    { provide: ErrorHandler, useClass: environment.logging?.enabled ? GlobalErrorHandler : ErrorHandler },
    { provide: APP_INITIALIZER, useFactory: startupServiceFactory, deps: [StartupService], multi: true },

    RouteNavigationService,
    LoggedInRouteGuardLogic,
    RedirectAfterService,
    UnauthenticatedInterceptor,
    LoggerService,
    StartupService,
    AuthenticationService,

    CampaignsService,
    CampaignSessionsService,
    CampaignSessionSectionsService,
    CampaignSessionSectionEntitiesService,
    CampaignPlayersService,
    GameEntitiesService,
    GameEntityTemplatesService,

    provideRouter(routes),
    provideAnimations(),

    importProvidersFrom(
      NgxsModule.forRoot([AppState], {
        developmentMode: !environment.production,
      }),
      NgxsSelectSnapshotModule.forRoot(),
      CoolHttpModule.forRoot(),
      CoolStorageModule.forRoot(),
      CoolDialogsModule.forRoot(),
    ),
  ],
};
